'use strict';

var ipDetectionValidation = function () {
    var deferred = jQuery.Deferred();
	let geolocationByBrowser = typeof desktopGeolocationByBrowser !== 'undefined' && !desktopGeolocationByBrowser  ? !Revealizr.isDesktopDevice : true;
    // Init ==============================================================
	// popup geolocation
	if (geolocationByBrowser && navigator.geolocation && TINK.getCookie("show-store-banner")
		&& !TINK.getCookie("geolocation-confirm") && !isInWebview()) {
		navigator.geolocation.getCurrentPosition(function (position) {

			$('body').addClass('in-progress ip-load');
			$('.fancybox-province-selector').remove();
			$.ajax({
				url: "/stores",
				data: {
					latitude: position.coords.latitude,
					longitude: position.coords.longitude
				},
				method: "GET",
				success: function (result) {
					if (result && result.id) {
						location.reload();
					}
				},
				error: function (jqXHR) {
					if (!TINK.redirectIfConflict(jqXHR)) {
						$('body').removeClass('in-progress ip-load');
						console.warn("Cannot retrieve store from geolocation [lat=" + position.coords.latitude +
							", long= " + position.coords.longitude + "]")
					}
				}
			});

		}, function (err) {
			var errorMessages = {1: "PERMISSION_DENIED", 2: "POSITION_UNAVAILABLE", 3: "TIMEOUT"};
			TINK.setCookie("geolocation-confirm", true, 365);
			// Show lightbox if no banner
			console.warn("Cannot retrieve geolocation code=" + errorMessages[err.code] + ", message=" + err.message);
		}, {
			enableHighAccuracy: true,
			timeout: 5000,
			maximumAge: 0
		});
	}

	// Set fancybox on the modal popup
	if (TINK.getCookie("show-store-banner") && $('#ipdetection--fancybox').length != 0) {
		//set localStorage to handle login popup appearance
		window.localStorage.setItem("fromIpDetectionFancyBox", "true");
		$.fancybox({
			'href':'#ipdetection--fancybox',
			'modal': true,
			afterShow:function __showFancyStoreLocator(){
				$('#modalFirstElem').attr('tabindex', 0).focus();
				$(this.inner).closest(".fancybox-overlay").addClass('fancybox-province-selector');
			}
		});
	}
    return deferred;
};

$(document).ready(function(){

// Init ==============================================================
//Calls browser vérification before ipDetectionValidation
//(Province selection message)
browserDetectionValidation()
	.then(ipDetectionValidation);

    // Binding ============================================================

    $('.ipdetectionFindMyStore').on('click',function(){
        TINK.setCookie("hide-store-banner", true);
    });

    $(".ipdetection--box button.ipdetection--box-yes").click(onClickSetMyStore);

    $("#ipdetection--fancybox .provinceSelector").on("click", function (e) {
        var programId = $(this).attr("data-program");
        var urlToCall = "/stores/my-store-for-program/" + programId;
        $.ajax({
            url: urlToCall,
            type: "POST",
            xhrFields: {
                withCredentials: true
            },
            success: function () {
				TINK.deleteCookies("hide-store-banner", "geolocation-confirm");
                location.reload();
            },
            error: function(jqXHR, status, error){
				if (!TINK.redirectIfConflict(jqXHR)) {
					console.warn("Cannot set store for program id " + programId + ", error=" + error);
				}
            }
        });
    });

    //FOCUS TRAP FOR PROVINCE SELECTOR
	$('#modalLastElem').on('keydown', function(e) {
		if($('this:focus') && (!e.shiftKey && e.which == 9)) {
			e.preventDefault();
			$('#modalFirstElem').focus();
		}
	});
	$('#modalFirstElem').on('keydown', function(e) {
		if($('this:focus') && (e.shiftKey && e.keyCode == 9)) {
			e.preventDefault();
			$('#modalLastElem').focus();
		}
	});

	//flyer store banner
	let $favoriteStorePopup = $('.popover-wrapper-ipdetection');
	if ($favoriteStorePopup.length) {
		$favoriteStorePopup.remodal().open();
	}

});